import React from 'react';
import ButtonsListContainer, { ButtonsListContainerProps } from './ButtonsListContainer';

export interface Props extends ButtonsListContainerProps {
  title: string;
}
const ButtonsRowWithTitle = (props: Props) => {
  const { title, ...buttonsListContainerProps } = props;
  return (
    <div id="buttons-row-with-title-wrapper" className="flex flex-row w-100">
      <div id="button-row-with-title-font" className="font-bold">
        {title}
      </div>
      <div id="button-row-with-title-end" className="flex w-full ml-2 justify-end">
        <ButtonsListContainer {...buttonsListContainerProps} />
      </div>
    </div>
  );
};

export default ButtonsRowWithTitle;
